import { useHistory } from 'react-router-dom'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../stories/atoms/button/constants'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import { Settings } from '../stories/atoms/icons/core'
import { HeaderButtons, TileImage } from './styled-component'
import ButtonComponent from '../stories/atoms/button'
import { projectListTabOption } from './constants'
import CompanyProjectsContextMenu from '../../containers/project-menu/components/company-projects-context-menu'
import { projectTreeItemTypeOptions } from '../../react-query/project/query/use-get-project-tree-query'
import { serializeQueryString } from '../../utils/urlManager'
import MyProjectsTableContextMenu from '../../containers/project-menu/components/my-projects-table-context-menu'
import { useProjectMenuListViewControl } from '../../hooks/use-project-menu-list-view-control'
import { ROLES } from '../../containers/TeamsManagement/constants'

const ProjectTileCardHeader = ({
  image,
  item,
  userPermissions,
  roleName = null,
  projectListOption = projectListTabOption.MY_PROJECTS,
  onLeaveProject = () => {},
  disabled
}) => {
  const { viewType, tab } = useProjectMenuListViewControl()
  const history = useHistory()
  const { title, id } = item || { title: null, id: null }

  const isMyProjectList = projectListOption === projectListTabOption.MY_PROJECTS

  const canSeeUserSettings = roleName && roleName === ROLES.POWERUSER

  const handleOpenProjectSettings = (e) => {
    e.stopPropagation()
    history.push(`/project/settings/${id}?view=${viewType}&tab=${tab}`)
  }

  const handleOnMoveProject = () => {
    if (item.type === projectTreeItemTypeOptions.FOLDER) {
      history.push(
        `/project/move/folder/${item.id}?view=${viewType}&tab=${tab}`
      )
      return
    }

    history.push(`/project/move/project/${item.id}?view=${viewType}&tab=${tab}`)
  }

  const handleOnCopyProject = () => {
    if (item.type !== projectTreeItemTypeOptions.PROJECT) return

    const queryString = serializeQueryString({
      ...(item.parentId && { folderId: item.parentId }),
      view: viewType,
      tab
    })

    history.push(`/project/${item.id}/copy${queryString}`)
  }

  const ContextMenuButton = () => {
    if (isMyProjectList)
      return (
        <MyProjectsTableContextMenu
          item={item}
          onCopyProject={handleOnCopyProject}
          onLeaveProject={onLeaveProject}
          isTileView
        />
      )

    return (
      <CompanyProjectsContextMenu
        item={item}
        onCopyProject={handleOnCopyProject}
        onMoveItem={handleOnMoveProject}
        userPermissions={userPermissions}
        isTileView
      />
    )
  }

  return (
    <TileImage background={image} alt={title} disabled={disabled}>
      <HeaderButtons>
        {canSeeUserSettings && (
          <ButtonComponent
            buttonType={buttonTypeOptions['ICON-ONLY']}
            variant={buttonVariantOptions['IMAGE-OVERLAY']}
            size={buttonSizeOptions.SMALL}
            onClick={handleOpenProjectSettings}
          >
            <Settings stroke={colorsOptions.greys.white} />
          </ButtonComponent>
        )}

        <ContextMenuButton />
      </HeaderButtons>
    </TileImage>
  )
}

export default ProjectTileCardHeader
